export default __webpack_public_path__ + "static/banner-3-b0db7c267a8b17b6d6eaf6086f092bfe.jpg";